


const PRODUCTION_BACKEND_BASE_URL = 'https://backend.getmoretats.com'
const LOCAL_BACKEND_BASE_URL = 'https://backend.getmoretats.com'

const BACKEND_BASE_URL = import.meta.env.DEV
  ? import.meta.env.VITE_BACKEND_BASE_URL || LOCAL_BACKEND_BASE_URL
  : PRODUCTION_BACKEND_BASE_URL

// All endpoints use the same base URL determined by environment
const VITE_FIREBASE_FUNCTIONS = {
  save_item: `${BACKEND_BASE_URL}/save-item`,
  unsave_item: `${BACKEND_BASE_URL}/unsave-item`,
  mcdonalds: `${BACKEND_BASE_URL}/mcdonalds`,
  scrape_instagram_profile: `${BACKEND_BASE_URL}/scrape-instagram-profile`,
  detect_flash_tattoo_design: `${BACKEND_BASE_URL}/detect-flash-tattoo-design`,
  finish_onboarding: `${BACKEND_BASE_URL}/finish-onboarding`,
  tattoo_search: `${BACKEND_BASE_URL}/tattoo-search`,
  query_tattoos: `${BACKEND_BASE_URL}/query-tattoos`,
  query_collections: `${BACKEND_BASE_URL}/query-collections`,
  artist_search: `${BACKEND_BASE_URL}/artist-search`,
  query_artists: `${BACKEND_BASE_URL}/query-artists`,
  chat_assistant_reply: `${BACKEND_BASE_URL}/chat-assistant-reply`,
  book_time: `${BACKEND_BASE_URL}/book-time`,
  compress_images: `${BACKEND_BASE_URL}/compress-images`,
  create_booking: `${BACKEND_BASE_URL}/create-booking`,
  cancel_booking: `${BACKEND_BASE_URL}/cancel-booking`,
  setup_calendar_watch: `${BACKEND_BASE_URL}/setup-calendar-watch`,
  embed_portfolio_items: `${BACKEND_BASE_URL}/embed-portfolio-items`,
  analytics: `${BACKEND_BASE_URL}/analytics`,
  core_analytics: `${BACKEND_BASE_URL}/core-analytics`,
  analyze_booking_from_chat: `${BACKEND_BASE_URL}/analyze-booking-from-chat`,
  create_gift_card_checkout: `${BACKEND_BASE_URL}/create-gift-card-checkout`,
  get_similar_items: `${BACKEND_BASE_URL}/get-similar-items`,
  query_tattoos_by_collection_similarity: `${BACKEND_BASE_URL}/query-tattoos-by-collection-similarity`,
  fyp: `${BACKEND_BASE_URL}/fyp`,
  artist_reachout_notification: `${BACKEND_BASE_URL}/artist-reachout-notification`,
  chat_analytics: `${BACKEND_BASE_URL}/chat-analytics`,
  delete_user_account: `${BACKEND_BASE_URL}/delete-user-account`,
  notification_tracking: `${BACKEND_BASE_URL}/notification-tracking`,
  pairwise_matcher_choose: `${BACKEND_BASE_URL}/pairwise-matcher/choose`,
  pairwise_matcher_result: `${BACKEND_BASE_URL}/pairwise-matcher/result`,
  pairwise_matcher_sessions: `${BACKEND_BASE_URL}/pairwise-matcher/sessions`,
  pairwise_matcher_sessions_list: `${BACKEND_BASE_URL}/pairwise-matcher/sessions/list`,
  pairwise_matcher_save_results: `${BACKEND_BASE_URL}/pairwise-matcher/session/save-results`,
  pairwise_matcher_session_delete: `${BACKEND_BASE_URL}/pairwise-matcher/session/delete`,
  invalidate_query_cache: `${BACKEND_BASE_URL}/invalidate-query-cache`,
  meta_conversions: `${BACKEND_BASE_URL}/meta-conversions`,
  query_community_posts: `${BACKEND_BASE_URL}/query-community-posts`,
  community_posts: `${BACKEND_BASE_URL}/community-posts`,
  community_posts_vote: `${BACKEND_BASE_URL}/community-posts/vote`,
  community_posts_vote_directions: `${BACKEND_BASE_URL}/community-posts/vote-directions`,
  community_comments: `${BACKEND_BASE_URL}/community-comments`,
  community_comments_query: `${BACKEND_BASE_URL}/community-comments/query`,
  community_comments_vote: `${BACKEND_BASE_URL}/community-comments/vote`,
  community_comments_vote_directions: `${BACKEND_BASE_URL}/community-comments/vote-directions`,
  board_post_drafts: `${BACKEND_BASE_URL}/board-post-drafts`,
}

export const ENDPOINTS = {
  ...VITE_FIREBASE_FUNCTIONS,

}

// Export individual endpoints for backwards compatibility
export const SAVE_ENDPOINT = ENDPOINTS.save_item
export const UNSAVE_ENDPOINT = ENDPOINTS.unsave_item 
export const MCDONALDS_ENDPOINT = ENDPOINTS.mcdonalds
export const SCRAPE_INSTAGRAM_PROFILE_ENDPOINT = ENDPOINTS.scrape_instagram_profile
export const DETECT_FLASH_TATTOO_DESIGN_ENDPOINT = ENDPOINTS.detect_flash_tattoo_design
export const FINISH_ONBOARDING_ENDPOINT = ENDPOINTS.finish_onboarding 
export const TATTOO_SEARCH_ENDPOINT = ENDPOINTS.tattoo_search
export const QUERY_TATTOOS_ENDPOINT = ENDPOINTS.query_tattoos
export const QUERY_COLLECTIONS_ENDPOINT = ENDPOINTS.query_collections
export const ARTIST_SEARCH_ENDPOINT = ENDPOINTS.artist_search
export const QUERY_ARTISTS_ENDPOINT = ENDPOINTS.query_artists
export const CHAT_ASSISTANT_REPLY_ENDPOINT = ENDPOINTS.chat_assistant_reply
export const COMPRESS_IMAGES_ENDPOINT = ENDPOINTS.compress_images
export const CREATE_BOOKING_ENDPOINT = ENDPOINTS.create_booking
export const CANCEL_BOOKING_ENDPOINT = ENDPOINTS.cancel_booking
export const SETUP_CALENDAR_WATCH_ENDPOINT = ENDPOINTS.setup_calendar_watch
export const EMBED_PORTFOLIO_ITEMS_ENDPOINT = ENDPOINTS.embed_portfolio_items
export const ANALYTICS_ENDPOINT = ENDPOINTS.analytics
export const CORE_ANALYTICS_ENDPOINT = ENDPOINTS.core_analytics
export const CREATE_GIFT_CARD_CHECKOUT_ENDPOINT = ENDPOINTS.create_gift_card_checkout
export const ANALYZE_BOOKING_FROM_CHAT_ENDPOINT = ENDPOINTS.analyze_booking_from_chat
export const ARTIST_REACHOUT_NOTIFICATION_ENDPOINT = ENDPOINTS.artist_reachout_notification
export const QUERY_TATTOOS_BY_COLLECTION_SIMILARITY_ENDPOINT = ENDPOINTS.query_tattoos_by_collection_similarity
export const FYP_ENDPOINT = ENDPOINTS.fyp
export const CHAT_ANALYTICS_ENDPOINT = ENDPOINTS.chat_analytics
export const DELETE_USER_ACCOUNT_ENDPOINT = ENDPOINTS.delete_user_account
export const INVALIDATE_QUERY_CACHE_ENDPOINT = ENDPOINTS.invalidate_query_cache
export const NOTIFICATION_TRACKING_ENDPOINT = ENDPOINTS.notification_tracking
export const PAIRWISE_MATCHER_CHOOSE_ENDPOINT = ENDPOINTS.pairwise_matcher_choose
export const PAIRWISE_MATCHER_RESULT_ENDPOINT = ENDPOINTS.pairwise_matcher_result
export const PAIRWISE_MATCHER_SESSIONS_ENDPOINT = ENDPOINTS.pairwise_matcher_sessions
export const PAIRWISE_MATCHER_SESSIONS_LIST_ENDPOINT = ENDPOINTS.pairwise_matcher_sessions_list
export const PAIRWISE_MATCHER_SAVE_RESULTS_ENDPOINT = ENDPOINTS.pairwise_matcher_save_results
export const META_CONVERSIONS_ENDPOINT = ENDPOINTS.meta_conversions
export const QUERY_COMMUNITY_POSTS_ENDPOINT = ENDPOINTS.query_community_posts
export const COMMUNITY_POSTS_ENDPOINT = ENDPOINTS.community_posts
export const COMMUNITY_POSTS_VOTE_ENDPOINT = ENDPOINTS.community_posts_vote
export const COMMUNITY_POSTS_VOTE_DIRECTIONS_ENDPOINT = ENDPOINTS.community_posts_vote_directions
export const COMMUNITY_COMMENTS_ENDPOINT = ENDPOINTS.community_comments
export const COMMUNITY_COMMENTS_QUERY_ENDPOINT = ENDPOINTS.community_comments_query
export const COMMUNITY_COMMENTS_VOTE_ENDPOINT = ENDPOINTS.community_comments_vote
export const COMMUNITY_COMMENTS_VOTE_DIRECTIONS_ENDPOINT = ENDPOINTS.community_comments_vote_directions
export const BOARD_POST_DRAFTS_ENDPOINT = ENDPOINTS.board_post_drafts

// Backwards-compat endpoint names (use environment-aware backend URL)
export const CREATE_BOOKING_ENDPOINT_PRODUCTION = `${BACKEND_BASE_URL}/create-booking`
export const CANCEL_BOOKING_ENDPOINT_PRODUCTION = `${BACKEND_BASE_URL}/cancel-booking`
